<template lang="pug">
.j-table(v-if="data")
  .column(v-if="showColumnHeader")
    .column-cell.color_text_3(
      v-for="(column, _) in data.column",
      :style="`width:${100/columnLength}%;`"
    ) {{column}}
  .row(:class="!showColumnHeader?'no-column': ''")
    .row-key_con
      table.row-key_table
        tr.row-key.color_text_3(v-for="(rowKey, _) in data.row.key")
          td.row-key_cell {{rowKey}}
    .row-value_con
      table.row-value_table
        tr.row-value(v-for="(rowValue, rIndex) in data.row.value")
          td.row-value_cell(
            v-for="(rowValueItem, cIndex) in rowValue",
            :style="`width:${100/columnLength}%;`",
          )
            .row-value_content(
              :class="(cellActivity.row===rIndex&&cellActivity.column === cIndex)?'color_bg_1 cell-active':''",
              @click="cellClickHandler(rowValueItem, rIndex, cIndex)"
            )
              template(v-if="rowValueItem.hiragana")
                .voice_icon
                .hiragana.color_text_1(
                  :class="showTypes.includes('hiragana')?'':'j-hidden'"
                ) {{rowValueItem.hiragana}}
                .katakana_romaji
                  .katakana.color_text_3(
                    :class="showTypes.includes('katakana')?'':'j-hidden'"
                  ) {{rowValueItem.katakana}}
                  .romaji.color_text_3(
                    :class="showTypes.includes('romaji')?'':'j-hidden'"
                  ) {{rowValueItem.romaji}}
</template>

<script>
import {
  defineComponent,
  computed,
  reactive,
  inject,
} from 'vue';
import voiceUtils from '@webfront-components-vue/voice-utils/dist/audio/index.umd';
import voiceConfig from '@/config/voiceConfig';

export default defineComponent({
  name: 'JTable',
  props: {
    data: Object,
    showTypes: Array,
    showColumnHeader: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, context) {
    let playTimerId = '';
    const pageStatus = inject('pageStatus');
    const columnLength = computed(() => {
      if (props.data && props.data.column && props.data.column.length > 0) {
        return props.data.column.length;
      }
      return 1;
    });
    const cellActivity = reactive({
      row: -1,
      column: -1,
    });
    const setCellActivity = (rIndex, cIndex) => {
      cellActivity.row = rIndex;
      cellActivity.column = cIndex;
    };
    let audioInstance;
    let audioInstanceSrc = '';
    const cellClickHandler = (rowValueItem, rIndex, cIndex) => {
      if (!pageStatus.isStudyMode.value) {
        // 非学习模式下统一进行发音
        const text = rowValueItem.hiragana;
        if (text) {
          const { audio, wordUrl } = voiceUtils({
            ...voiceConfig,
            word: decodeURIComponent(text),
            yduuid: 'abcdefg',
            le: 'jap',
          });
          // eslint-disable-next-line
          if (wordUrl === audioInstanceSrc) {
            return;
          }
          audioInstance = audio;
          audioInstanceSrc = wordUrl;
          // eslint-disable-next-line
          window._rlog.push([
            '_trackCustom',
            'japanese50',
            [
              ['aciton', 'syllabary_pronounce'],
              ['source', 'normal'],
            ],
          ]);
          if (playTimerId) {
            clearTimeout(playTimerId);
            playTimerId = '';
          }
          setCellActivity(rIndex, cIndex);
          audioInstance.play();
          playTimerId = setTimeout(() => {
            // eslint-disable-next-line
            audioInstance = null;
            setCellActivity(-1, -1);
          }, 1500);
        }
      } else if (pageStatus.voiceType.value === 'voiceless') {
        // 学习模式下并且处于清音tab下，通知清音组件展示默写浮层
        context.emit('j-cell-click', {
          rowValueItem,
          rIndex,
          cIndex,
        });
      }
    };
    return {
      columnLength,
      cellActivity,
      cellClickHandler,
    };
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .j-table
    .j-hidden
      visibility hidden
    .column
      margin-left 0.28rem
      font-size 0
      .column-cell
        display inline-block
        height 0.6rem
        line-height 0.6rem
        font-size 0.2rem
        text-align center
    .no-column
      margin-top 0.32rem
    .row
      td.row-key_cell, td.row-value_cell
        position relative
        z-index 1
        height 1.34rem
        text-align center
        border 1px solid rgba(254, 230, 229, 0.5)
        padding 0
      td.row-key_cell
        border 1px solid transparent
      .row-key_con
        width 0.52rem
        float left
        .row-key_cell
          line-height 1.34rem
          font-size 0.2rem
          width 0.52rem
      .row-value_con
        margin-left 0.52rem
      .row-value_table, .row-key_table
        width 100%
        border-spacing 0
        border-collapse collapse
        border 1px solid #FEE6E5
        border-style hidden // 消除外边框
      .row-value_table
        border-radius 0.32rem
        box-shadow: 0 0 0 2px #FEE6E5
        background rgba(254, 230, 229, 0.15)
      .row-value_content
        height 1.34rem
        .voice_icon
          display none
          width 0.32rem
          height 0.32rem
          background url("../assets/ic_result_voice_.png") 50% 50% no-repeat
          background-size contain
          position absolute
          top 0.12rem
          right 0.12rem
          z-index 2
      .hiragana
        font-family NotoSerifJP
        font-size 0.4rem
        line-height 0.4rem
        padding-top 0.3rem
        margin-bottom 0.06rem
      .katakana_romaji
        font-size 0
        height 0.34rem
        line-height 0.34rem
        .katakana, .romaji
          display inline-block
          width 50%
          font-size 0.28rem
        .romaji
          font-size 0.32rem
      .row-value_content.cell-active
        position absolute
        top -0.1rem
        left -0.1rem
        right  -0.1rem
        bottom  -0.1rem
        /*background white*/
        box-shadow 0px 0.08rem 0.24rem rgba(251, 74, 62, 0.08)
        border-radius 0.24rem
        height auto
        .voice_icon
          display block
          animation audioPlaying 0.8s infinite
          -webkit-animation audioPlaying 0.8s infinite
        .hiragana
          color #FB4A3E
        .katakana, .romaji
          color rgba(251, 74, 62, .7)
</style>
<style lang="stylus" scoped>
  .dark
    .j-table
      .row
        .row-value_table, .row-key_table
          width 100%
          border-spacing 0
          border-collapse collapse
          border 1px solid #401510
          border-style hidden // 消除外边框
        .row-value_table
          border-radius 0.32rem
          box-shadow: 0 0 0 2px #401510
          background rgba(64, 21, 16, 0.15)
          .row-value_content.cell-active
            position absolute
            top -0.1rem
            left -0.1rem
            right  -0.1rem
            bottom  -0.1rem
            box-shadow 0px 0.08rem 0.24rem rgba(251, 74, 62, 0.08)
            border-radius 0.24rem
            height auto
            .voice_icon
              animation audioPlayingDark 0.8s infinite
              -webkit-animation audioPlayingDark 0.8s infinite
            .hiragana
              color #FB4A3E
            .katakana, .romaji
              color rgba(251, 74, 62, .7)
        td.row-key_cell, td.row-value_cell
          border 1px solid rgba(64, 21, 16, 0.5)
</style>
